import { roundMoney, toMoney } from './money.js';
import type { DocumentLine } from './subledger.js';

export type { DocumentLine } from './subledger.js';

export type LineTotals = {
  net: string;
  tax: string;
  gross: string;
};

export function lineTotals(line: DocumentLine): LineTotals {
  const qty = toMoney(line.quantity);
  const unit = toMoney(line.unitPrice);
  const net = roundMoney(qty.times(unit));
  const tax = roundMoney(toMoney(net).times(line.taxRatePercent).div(100));
  const gross = roundMoney(toMoney(net).plus(tax));
  return { net, tax, gross };
}

export function documentTotals(lines: DocumentLine[]): LineTotals {
  let net = toMoney(0);
  let tax = toMoney(0);
  for (const line of lines) {
    const t = lineTotals(line);
    net = net.plus(t.net);
    tax = tax.plus(t.tax);
  }
  return {
    net: roundMoney(net),
    tax: roundMoney(tax),
    gross: roundMoney(net.plus(tax))
  };
}
